export default __webpack_public_path__ + "562693940dd2286e7a397c97c77ed773.svg";